import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ProjectFileItem } from '@app/shared/interfaces/file.interface';
import { FileInfoComponent } from '../file-info.component';

@Component({
  standalone: true,
  selector: 'app-file-info-dialog',
  templateUrl: './file-info-dialog.component.html',
  styleUrls: ['./file-info-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    FlexLayoutModule,
    FileInfoComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileInfoDialogComponent {
  dialogRef = inject<MatDialogRef<FileInfoDialogComponent>>(MatDialogRef);
  file = inject<ProjectFileItem>(MAT_DIALOG_DATA);


  closeDialog(): void {
    this.dialogRef.close();
  }
}
